import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import { MediaData } from "@/types/types"

const guessMimeFromUrl = (url: string) => {
  const ext = url.split("?")[0].split(".").pop()?.toLowerCase() || ""
  if (["mp4", "webm", "ogg"].includes(ext)) return `video/${ext === "ogv" ? "ogg" : ext}`
  if (["mp3", "wav", "ogg"].includes(ext)) return `audio/${ext}`
  if (["jpg", "jpeg", "png", "gif", "webp", "avif", "svg"].includes(ext)) return `image/${ext === "jpg" ? "jpeg" : ext}`
  if (ext === "pdf") return "application/pdf"
  return "application/octet-stream"
}

const escapeHtml = (s: string) =>
  s ? s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;") : ""

export const buildMediaHTML = (media: MediaData) => {
  const url = `${ADMIN_API_CONFIG.API_URL}${media.url}`
  const mime = (media as any).mime || guessMimeFromUrl(url)
  const alt = escapeHtml(media.alternativeText || media.name || "")
  const cap = escapeHtml(media.caption || "")

  // ẢNH
  if (mime.startsWith("image/")) {
    return `
<figure class="image">
  <img src="${url}" alt="${alt}" />
  ${cap ? `<figcaption>${cap}</figcaption>` : ""}
</figure>`
  }

  // VIDEO (ví dụ: https://.../uploads/abc.mp4)
  if (mime.startsWith("video/")) {
    return `
<figure class="ck-media video">
  <video controls preload="metadata" playsinline
         style="width:100%;height:auto;aspect-ratio:16/9;border-radius:8px;display:block;">
    <source src="${url}" type="${mime}" />
    Trình duyệt của bạn không hỗ trợ video.
  </video>
</figure>`
  }

  // AUDIO
  if (mime.startsWith("audio/")) {
    return `
<figure class="ck-media audio">
  <audio controls preload="metadata" style="width:100%;">
    <source src="${url}" type="${mime}" />
    Trình duyệt của bạn không hỗ trợ audio.
  </audio>
  ${cap ? `<figcaption>${cap}</figcaption>` : ""}
</figure>`
  }

  // PDF => nhúng hoặc link
  if (mime === "application/pdf") {
    return `
<figure class="ck-media pdf">
  <div class="pdf-wrap" style="position:relative;padding-bottom:141%;height:0;max-width:100%;">
    <iframe src="${url}#view=FitH" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;"></iframe>
  </div>
  <figcaption><a href="${url}" target="_blank" rel="noopener">Mở PDF</a>${cap ? ` – ${cap}` : ""}</figcaption>
</figure>`
  }

  // File khác => link tải
  return `
<p class="file-link">
  <a href="${url}" target="_blank" rel="noopener" download>${media.name || "Tải tệp"}</a>
</p>`
}
